import React from 'react'
import { cn, RectangleButton, BottomSheet } from '@yanolja-rnd/nol-design-system'
import { useDeviceType } from '~/app/utils/useDeviceType'
import { CartPageLog } from '~/app/kinesis/protobuf/clientlogs/order-misc-common-txtpb'
import Impression from '~/app/components/common/Impression'
import { zIndexExtra } from '~/app/components/styles/units'

type GoldClassBenefitsProps = {
  /** 바텀 시트 오픈 여부 */
  isOpen: boolean
  /** 바텀 시트 닫기 핸들러 */
  onClose: () => void
  /** 계속 구매하기 버튼 클릭 핸들러 */
  onClickContinuePurchaseButton: () => void
  /** 할인 가격 텍스트 */
  vipDiscountPriceText: string
  /** 할인 옵션 ID 리스트 */
  discountOptionList: {
    propertyId: number
    roomTypeId: number
    ratePlanId?: number
    badgeMemberCode?: string
  }[]
}

const GoldClassBenefitsBottomSheet: React.FC<GoldClassBenefitsProps> = ({
  isOpen,
  onClose,
  onClickContinuePurchaseButton,
  vipDiscountPriceText,
  discountOptionList,
}) => {
  const deviceType = useDeviceType()

  const trackImpression = async () => {
    if (discountOptionList.length > 0) {
      await CartPageLog.PriceChangeDownInfoBottomSheet.impression({
        priceChangedItems: JSON.stringify(discountOptionList),
      })
    }
  }

  return (
    <Impression onImpressed={trackImpression}>
      <BottomSheet
        isOpen={isOpen}
        os={deviceType}
        zIndex={zIndexExtra}
        height="contents"
        footer={
          <RectangleButton
            theme="filled_primary"
            weight="bold"
            fullWidth
            size="large"
            onClick={async () => {
              await CartPageLog.PriceChangeDownInfoBottomSheetButtonOrder.click({
                priceChangedItems: JSON.stringify(discountOptionList),
              })
              onClickContinuePurchaseButton()
              onClose()
            }}
          >
            계속 구매하기
          </RectangleButton>
        }
        onClose={onClose}
        dialogOptions={{
          onBackdropClick: () => {
            deviceType === 'etc' && onClose()
          },
        }}
      >
        <div
          className={cn(
            'px-16 pb-20 pt-8 text-center typography-subtitle-16-bold-multiline',
            'pf-pc:px-0 pf-pc:pt-20'
          )}
        >
          <div className="rounded-12 bg-fill-warning-weak px-16 py-10">
            <span>Gold Class 혜택이 적용되어</span>
            <br />
            <span className="text-text-accent-medium">{vipDiscountPriceText}</span>
            <span> 더 할인받았어요!</span>
          </div>
        </div>
      </BottomSheet>
    </Impression>
  )
}

export default GoldClassBenefitsBottomSheet
